<!-- 设置推广内容弹窗 -->
<template>
<a-modal :visible="tg_modal" title="批量设置推广内容" okType="primary" width="800px"
  okText="设置" cancelText="取消"
  @ok="tgOk" @cancel="tgCancel" :confirmLoading="tg_loading">
	<div style="">
		<div style="display: flex;align-items: center;margin-bottom: 15px;">
			<div style="margin-right: 15px;font-size: 15px;">渠道内容</div>
			<a-select
				style="width: 500px"
				placeholder="请选择渠道内容"
				@change="handleChangeQ"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="tg_value"
			  >
				<a-select-option v-for="(value,key) in ContentChannel" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		<div style="display: flex;align-items: center;margin-bottom: 30px;">
			<div style="margin-right: 15px;font-size: 15px;width: 60px;">作品</div>
			
			<tfBookSelect ref="getTfBook" s_width="500px" s_contr="1" @handleChangeSelect="handleChangeZ"></tfBookSelect>
			<!-- <putBookS s_width="300px" ref="getPutBook" @handleChangeSelect="handleChangeZ"></putBookS> -->
			
		</div>
		<div style="margin-bottom: 10px;margin-top: 15px;">已选的账号名称：</div>
		<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
			<template v-if="adv_type != 3 && adv_type != 2 && adv_type != 4">
				<template v-if="selectedData_dan.length > 0">
					<div v-for="(item,index) in selectedData_dan" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 130px;">{{item.adv_name}}</div>
					</div>
				</template>
				<template v-else>
					<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 130px;">{{item.adv_name}}</div>
					</div>
				</template>
			</template>
			<!-- 百度 -->
			<template v-if="adv_type == 3">
				<template v-if="selectedData_dan.length > 0">
					<div v-for="(item,index) in selectedData_dan" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">{{item.bd_user_id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 140px;">{{item.bd_user_name}}</div>
					</div>
				</template>
				<template v-else>
					<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">{{item.bd_user_id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 140px;">{{item.bd_user_name}}</div>
					</div>
				</template>
			</template>
			<!-- 腾讯 -->
			<template v-else-if="adv_type == 2">
				<template v-if="selectedData_dan.length > 0">
					<div v-for="(item,index) in selectedData_dan" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">{{item.account_id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 180px;">{{item.account_name}}</div>
					</div>
				</template>
				<template v-else>
					<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">{{item.account_id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 180px;">{{item.account_name}}</div>
					</div>
				</template>
			</template>
			<!-- 快手 -->
			<template v-else-if="adv_type == 4">
				<template v-if="selectedData_dan.length > 0">
					<div v-for="(item,index) in selectedData_dan" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">{{item.advertiser_id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 130px;">{{item.advertiser_name}}</div>
					</div>
				</template>
				<template v-else>
					<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
						<div style="width: 70px;text-align: right;">{{item.advertiser_id}}</div>
						<span style="margin: 0 5px;"> — </span>
						<div style="width: 130px;">{{item.advertiser_name}}</div>
					</div>
				</template>
			</template>
		</div>
	</div>
</a-modal>
</template>

<script>
import { setAdvContentType } from '@/request/api'
import jlAdvSelect from '@/views/Market/JLpages/components/jlAdvSelect.vue'
import putBookS from '@/views/PutData/components/putBookS.vue'
import tfBookSelect from '@/components/selectCompont/tfBookSelect.vue'
export default {
	name: 'tgContentModal_',
	components: {
		jlAdvSelect, putBookS, tfBookSelect
	},
	props: ['ContentChannel', 'bookID', 'selectedData', 'adv_type'],
	data() {
		return {
			// 推广内容
			tg_modal: false,
			tg_loading: false,
			tg_value: undefined,
			tg_book_id: undefined,
			selectedData_dan: [],
			
		}
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeQ(e){ // 渠道内容
			this.tg_value = e
			let eee = 1
			if(e == 3){
				eee = 2
			}
			this.$refs.getTfBook.changeType(eee)
			// 清空
			this.$refs.getTfBook.getClose()
			this.tg_book_id = undefined
		},
		handleChangeZ(e){ // 作品
			this.tg_book_id = e
		},
		
		clickTgnr(item){
			let that = this
			console.log("item",item);
			this.selectedData_dan = []
			this.selectedData_dan.push(item)
			
			that.tg_modal = true
			let kkk = ""
			if(item.content_channel){
				
				for (let key in that.ContentChannel) {
					if(item.content_channel == that.ContentChannel[key]){
						console.log("tg_value",key);
						kkk = key
					}
				}
				that.$nextTick(()=>{
					that.tg_value = kkk
				})
			}
			if(item.book_id){
				that.tg_book_id = item.book_id
				that.$nextTick(()=>{
					// that.$refs.getPutBook.getEdit(item.book_id)
					let eee = 1
					if(item.content_channel && kkk == 3){
						eee = 2
					}
					that.$refs.getTfBook.getEdit(item.book_id, eee)
				})
			}
			
			that.$nextTick(()=>{
				// that.$refs.getPutBook.getSelectData(that.bookID || [])
				that.$refs.getTfBook.getSelectData()
			})
		},
		tgOk(){
			let that = this
			
			if(!that.tg_value){
				that.$message.warning('请先选择渠道内容');
				return
			}
			else if(!that.tg_book_id){
				that.$message.warning('请先选择作品');
				return
			}
			
			let a_id = []
			if(that.adv_type != 3 && that.adv_type != 2 && that.adv_type != 4){ // 巨量、微博
				if(that.selectedData_dan.length > 0){
					that.selectedData_dan.forEach(res=>{
						a_id.push(res.adv_id)
					})
					
				}
				else if(that.selectedData.length > 0){
					that.selectedData.forEach(res=>{
						a_id.push(res.adv_id)
					})
				}
			}
			
			if(that.adv_type == 3){ // 百度
				if(that.selectedData_dan.length > 0){
					that.selectedData_dan.forEach(res=>{
						a_id.push(res.bd_user_id)
					})
					
				}
				else if(that.selectedData.length > 0){
					that.selectedData.forEach(res=>{
						a_id.push(res.bd_user_id)
					})
				}
			}
			else if(that.adv_type == 2){ // 腾讯
				if(that.selectedData_dan.length > 0){
					that.selectedData_dan.forEach(res=>{
						a_id.push(res.account_id)
					})
					
				}
				else if(that.selectedData.length > 0){
					that.selectedData.forEach(res=>{
						a_id.push(res.account_id)
					})
				}
			}
			else if(that.adv_type == 4){ // 快手
				if(that.selectedData_dan.length > 0){
					that.selectedData_dan.forEach(res=>{
						a_id.push(res.advertiser_id)
					})
					
				}
				else if(that.selectedData.length > 0){
					that.selectedData.forEach(res=>{
						a_id.push(res.advertiser_id)
					})
				}
			}
			
			that.tg_loading = true
			
			setAdvContentType({
				adv_ids: a_id,
				adv_type: that.adv_type, // 广告账户类型，1=巨量，2=腾讯，3=百度，4=快手，5=微博
				book_id: that.tg_book_id,
				content_channel: that.tg_value,
			}).then(res=>{
				that.tg_loading = false
				console.log("设置推广内容",res);
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.tgCancel()
					that.$message.success('操作成功');
					
					that.$emit("set-adv-ok","")
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
		},
		tgCancel(){
			// this.$refs.getPutBook.getClose()
			this.$refs.getTfBook.clearValue()
			this.tg_book_id = undefined
			
			this.tg_modal = false
			this.tg_loading = false
			
			this.tg_value = undefined
			this.selectedData_dan = []
		},
		
		plTg(){
			let that = this
			
			that.tg_modal = true
			that.$nextTick(()=>{
				// that.$refs.getPutBook.getSelectData(that.bookID || [])
				that.$refs.getTfBook.getSelectData()
			})
		}
	}
}
</script>

<style scoped>
</style>